import { render, staticRenderFns } from "./myInquire.vue?vue&type=template&id=5dbdb688&scoped=true"
import script from "./myInquire.vue?vue&type=script&lang=js"
export * from "./myInquire.vue?vue&type=script&lang=js"
import style0 from "./myInquire.vue?vue&type=style&index=0&id=5dbdb688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbdb688",
  null
  
)

export default component.exports